import gql from 'graphql-tag';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import { withRouter, Redirect } from 'react-router-dom';

const GET_AUTH = gql`
  query authStatus {
    authStatus @client {
      status
    }
  }
`;

const AuthRoute = ({
  children,
  location,
  beforeRedirect,
  unauthorizedPagePath,
  redirectPathOnLoggedOut,
}) => {
  const { data } = useQuery(GET_AUTH);
  const { pathname } = location;

  if (data.authStatus.status === 'loggedOut' && pathname !== redirectPathOnLoggedOut) {
    beforeRedirect();

    window.location.href = redirectPathOnLoggedOut;
    return null;
  }

  if (data.authStatus.status === 'unauthorized' && !location.state) {
    beforeRedirect();

    return <Redirect to={unauthorizedPagePath} />;
  }

  return (
    <>{children}</>
  );
};

AuthRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  location: PropTypes.object.isRequired,
  redirectPathOnLoggedOut: PropTypes.string,
  unauthorizedPagePath: PropTypes.string,
  beforeRedirect: PropTypes.func,
};

AuthRoute.defaultProps = {
  redirectPathOnLoggedOut: '',
  unauthorizedPagePath: '',
  beforeRedirect: () => {},
};

export default withRouter(AuthRoute);
